<template>
  <div id='codeAdd'>
    <!-- 个人信息 -->
    <el-form :inline="true" class="demo-ruleForm" :model="examcode" :rules="rules" ref="examcode">
      <fieldset style="border-width: 2px; border-color: #990000; width:98%; height:220">
        <el-row>
          <el-col :span="3" class="c">
            代码类别名称 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="name" id="name">
              <el-input v-model="examcode.name" :maxlength="25" placeholder="请输入内容" class="DataWidth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3"  class="c">
            代码类别 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="type" id="type">
              <el-input v-model="examcode.type" :maxlength="25" placeholder="请输入内容" class="DataWidth"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3"   class="c">
            代码名称 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="value" id="value">
              <el-input v-model="examcode.value" :maxlength="25" placeholder="请输入内容" class="DataWidth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            代码值 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="code" id="code">
              <el-input v-model="examcode.code" :maxlength="25" placeholder="请输入内容" class="DataWidth"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            是否可用 <span style="color:red;">*</span>
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="flag" id="flag">
              <el-select v-model="examcode.flag" placeholder="请选择" class="DataWidth">
                <el-option v-for="item in options_flag" :key="item.code" :label="item.value" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            备注
          </el-col>
          <el-col :span="5">
            <el-form-item label="" prop="remark" id="remark">
              <el-input type="textarea" :rows="2" style="width:400px" v-model="examcode.remark" placeholder="请输入内容"
                        class="DataWidth">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>


    <!-- 功能按钮 -->
    <el-row style="margin-top:15px">
      <el-col :span="20">&nbsp;
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="" @click='reset' v-show="false">清屏</el-button>
      </el-col>
      <el-col :span="2" v-show="isSave">
        <el-button type="primary" icon="save" @click='save'>保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    name: 'codeAdd',
    created: function () {
      this.options_flag = this.CommonUtil.getCodeList("status");
    },
    mounted: function() {
      this.examcode=this.codeRow;
    },
    watch: {
      "codeRow": function () {
        this.examcode = this.codeRow;
      },
    },
    props: ["codeRow"],
    data() {
      return {
        msg: 'Welcome to Your codeAdd',
        isSave: true,
        examcode: {
          type: '',
          name: '',
          code: '',
          value: '',
          flag: '1',
          remark: ''
        },
        options_flag: [],
        // 测试验证
        rules: {
          name: [{
            required: true,
            message: '请填写名称',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      reset: function () {
        this.$refs['examcode'].resetFields();
      },
      // 保存
      save: function () {
        this.$refs['examcode'].validate((valid) => {
          if (valid) {
            this.$axios.post('/code/codeAdd', this.examcode).then((response) => {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.$root.eventHub.$emit(this.GLOBAL.COLSECODE);
              this.reset();
            })
          } else {
            this.$message({
              message: '请检查填写内容，红色区域为必填项',
              type: 'error'
            });
          }
        });
      }
    }
  }
</script>
<style scoped>
  div {
    margin-top: 0px;
  }

  .c {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/code/codeEdit.vue